export default __webpack_public_path__ + "static/media/exclamation.59177c48.svg";